import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'
import { Oauth2ServerConnectionType } from '~/plugins/data-connector/authentication/strategies/oauth2/oauth2.server'

export const ProviderAsanaCommon = {
  key: 'asana',
  authentication: ProviderAuthenticationCommon.Oauth2({
    key: 'asana',
    authUrl: 'https://app.asana.com/-/oauth_authorize',
    tokenUrl: 'https://app.asana.com/-/oauth_token',
    scopes: ['default'],
  }),
}

export type ProviderAsanaAccountType = {
  access_token: string
  token_type: 'bearer'
  expires_in: number
  data: {
    id: number
    gid: string
    name: string
    email: string
  }
  refresh_token: string
}

export type ProviderAsanaConnectionType = Oauth2ServerConnectionType & {
  data?: {
    id: number
    gid: string
    name: string
    email: string
  }
}
